/***************************************************
 Init carousel
***************************************************/
// Uses tiny slider vendor/tiny-slider.scss

function initCarousel(itms){
  var hasAltNavClss = ".has-alt-tns-nav";// include .
  var altNavClss = "alt-tns-nav";

  for(var i = 0; i < itms.length; i++){
    init(itms[i], i);
  }

  function init(c, indx){
    // Carousel will need an ID
    if(!c.id) c.id =  "carousel-"+indx;

    var slider = tns({
      container: '#'+c.id,
      items: 1
    });

    var destroyBP = (c.dataset.destroy) ? c.dataset.destroy.trim() : null;

    if(destroyBP && destroyBP!="" ){
      // if we have a data set for destroying the slider
      if(destroyBP=="sm" ){
        // if it destroys itself in small
        if(getSize().w < 640 ){
          // small, destroy
          slider.destroy();
        }
      }
    }

    // Set alternative navigation if any
    var altNavPrnt = findAncestor(document.querySelector('#'+c.id), hasAltNavClss);
    if(altNavPrnt){
      setAltNavigation(altNavPrnt.querySelector("."+altNavClss),  slider, '#'+c.id, altNavPrnt, destroyBP);
    }
  }// init()

  function setAltNavigation(navWrapper, sldr, controls, mainWrapper, dstryBP){
    if(navWrapper){
      // we have a navigation
      var navItems = navWrapper.querySelectorAll("a");
      if(navItems.length){
        navItems.forEach( function(itm, i) {
          itm.addEventListener("click", function(e){
            e.preventDefault();
            sldr.goTo(i);
            if(getSize().w <  640){
              smoothScroll(0, getOffset(document.querySelector(controls)).top, 90);
            }
          });
        });
      }
      // check if it has a destroy breakpoint
      if(dstryBP){
        if (dstryBP == "sm" && getSize().w < 640  ){
          mainWrapper.classList.add("tns-disabled");
        }
      }
    }
  }//setAltNavigation()
}//initCarousel


/***************************************************
  Document init
***************************************************/
// DOM Loaded
DOMReady(function() {
  var items = document.querySelectorAll(".is-carousel");
  if(items.length > 0 ) initCarousel(items);
});